<template>
  <b-sidebar
    id="sidebar-create-direction"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ direction.id ? $t('Update Direction') : 'Create Direction' }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <!-- Uz Name -->
        <b-form-group
          :label="$t('name uz')"
          label-for="uz-name"
        >
          <b-form-input
            id="uz-name"
            v-model="direction.name.uz"
            trim
          />
        </b-form-group>

        <!-- Ru Name -->
        <b-form-group
          :label="$t('name ru')"
          label-for="ru-name"
        >
          <b-form-input
            id="ru-name"
            v-model="direction.name.ru"
            trim
          />
        </b-form-group>

        <!-- En Name -->
        <b-form-group
          :label="$t('name en')"
          label-for="en-name"
        >
          <b-form-input
            id="en-name"
            v-model="direction.name.en"
            trim
          />
        </b-form-group>

        <!-- Code -->
        <b-form-group
          :label="$t('Code')"
          label-for="code"
        >
          <b-form-input
            id="code"
            v-model="direction.code"
            trim
          />
        </b-form-group>
        <!-- Category Subject Id -->
        <b-form-group
          :label="$t('Category Subject')"
          label-for="category_subject_id"
        >
          <b-form-select
            id="category_subject_id"
            v-model="direction.category_subject"
            :options="categorySubjects"
            value-field="id"
            :text-field="'name.'+$i18n.locale"
          />
        </b-form-group>

        <b-form-group
          :label="$t('Ustuvor')"
          label-for="is_priority"
        >
          <b-form-checkbox
            id="is_priority"
            v-model="direction.is_priority"
            switch
          />
        </b-form-group>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ direction.id ? $t('Update Direction') : $t('Create Direction') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BButton, BFormSelect, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormSelect,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  computed: {
    direction: {
      get() {
        return this.$store.state.direction.direction
      },
      set(data) {
        this.$store.commit('direction/UPDATE', data)
      },
    },
    categorySubjects: {
      get() {
        return this.$store.state['category-subject'].categorySubjects
      },
    },
  },
  created() {
    this.$store.dispatch('category-subject/list', { limit: 1000 })
  },
  methods: {
    clear(hide) {
      this.$store.commit('direction/FRESH')
      hide()
    },
    submit(hide) {
      this.$createSwal(this, this.direction, `direction/${this.direction.id ? 'update' : 'create'}`, () => {
        this.$emit('refetchData')
        this.$store.commit('direction/FRESH')
      })
      hide()
    },
  },
}
</script>
